import { AlertCircle } from 'lucide-react';
import { Helmet } from 'react-helmet';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

import Logo from '../../assets/img/mar-shopping-landscape.svg';

import Heading from '../typography/heading.jsx';

/**
 * The root boundary component that handles all route errors
 * @return {JSX.Element} The root boundary component
 */
export const RootBoundary = () => {
  const error = useRouteError();

  return (
    <div
      style={{
        gridTemplateRows: 'auto 1fr',
        gridTemplateColumns: 'minmax(0, 1fr)',
      }}
      className="grid min-h-[100svh] gap-10 py-10"
    >
      <Helmet>
        <title>Portal de Campanhas - MAR SHOPPING</title>
      </Helmet>

      <div>
        <img src={Logo} alt="Logo" className="mx-auto h-10 w-auto" />
      </div>

      <div className="flex flex-col items-center justify-center">
        <AlertCircle className="mb-4 size-32 text-destructive" />

        {isRouteErrorResponse(error) ? (
          <>
            {error.status === 404 ? (
              <Heading>Esta página não existe</Heading>
            ) : error.status === 401 ? (
              <Heading>Não está autorizado para ver esta página</Heading>
            ) : (
              <Heading className="font-medium text-destructive">
                Ocorreu um erro inesperado
              </Heading>
            )}
          </>
        ) : (
          <Heading>Ocorreu um erro inesperado</Heading>
        )}
      </div>
    </div>
  );
};
